import { getAuthProps, setAuthProps, signOut } from "@/services";
import { createSlice } from "@reduxjs/toolkit";


const authData = getAuthProps();

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: authData != null,
    studentId: authData?.studentId,
    token: authData?.token,
    authData,
    isLogedin: !!authData,
    email: authData?.email,
    fullName: authData?.fullName,
    firstName: authData?.firstName || "",
    middleName: authData?.middleName || "",
    lastName: authData?.lastName || "",
    needReview: authData?.needReview,
    entryFrom: authData?.entryFrom,
    apaarId: authData?.apaarId,
    isRegistrationReviewed: authData?.isRegistrationReviewed || false,
    reviewed: authData?.reviewed,
    instituteName: authData?.instituteName,
    departmentName: authData?.departmentName,
    uskId: authData?.uskId,
    contact: authData?.contact,
  },
  reducers: {
    authentication: (state, action) => {
      const authData = action.payload;
      setAuthProps(authData);
      state.isLogedin = true;
      state.authData = authData;
      state.email = authData.email;
      state.isAuthenticated = true;
      state.token = authData.token;
      state.apaarId = authData.apaarId
      state.fullName = authData.fullName;
      state.firstName = authData.firstName || "";
      state.middleName = authData.middleName || "";
      state.lastName = authData.lastName || "";
      state.studentId = authData.studentId;
      state.instituteName = authData.instituteName,
        state.departmentName = authData.departmentName,
        state.uskId = authData?.uskId,
        state.contact = authData?.contact
      /* 
        ** NOTE: This flag controls whether the user is shown the Student Registration page or redirected to the Portal Selection page.
      */
      state.entryFrom = authData.entryFrom
      state.reviewed = authData.reviewed
    },
    logout: (state) => {
      state.isLogedin = false;
      signOut();
    },

    // NOTE: Once the student completes the form and confirms the review, always redirect them to the Portal Selection page.
    confirmRegistrationReview: (state) => {
      state.isRegistrationReviewed = true;
      const currentAuthData = getAuthProps() || {};
      setAuthProps({
        ...currentAuthData,
        isRegistrationReviewed: true
      });
    },

    setApaarId: (state, action) => {
      const apaarId = action.payload;
      state.apaarId = apaarId;
      const currentAuthData = getAuthProps() || state.authData || {};
      const updatedAuthData = {
        ...currentAuthData,
        apaarId: apaarId
      };
      setAuthProps(updatedAuthData);
      state.authData = updatedAuthData;
    }
  },
});

export const { authentication, logout, confirmRegistrationReview, setApaarId } = authSlice.actions;
export default authSlice.reducer;
